module.exports = __webpack_public_path__ + "static/media/icon-arrow-left-grey.2e0837d4.svg";